import localForage from "localforage";
export default localForage;
